var stateLst = '|AK|AL|AR|AZ|CA|CO|CT|DC|DE|FL|GA|HI|IA|ID|IL|IN|KS|KY|LA|MA|MD|ME|MI|MN|MO|MS|MT|NC|ND|NE|NH|NJ|NM|NV|NY|OH|OK|OR|PA|PR|RI|SC|SD|TN|TX|UT|VA|VT|WA|WI|WV|WY|';
var canadaLst = '|AB|BC|MB|NB|NF|NT|NS|NU|ON|PE|QC|SK|YT|';
var mexicoLst = '|AGS|BCN|BCS|CAM|CHI|COA|COL|DF|DGO|EDM|GTO|GRO|HGO|JAL|MIC|MOR|NAY|NL|OAX|PUE|QRO|Q_R|SLP|SIN|SON|TAB|TAM|TLX|VER|YUC|ZAC|';
var usZipRegEx = /^\d{5}(\-(\d{4})?)?$/;
var canadaZipRegEx = /^([a-zA-Z]\d[a-zA-Z] ?\d[a-zA-Z]\d)$/;

$(function () {
    $(".PEPCheckbox").click(function () {
        // Keeps the associated hidden checkbox value in synch for consistent posting (The checkbox id should be the same id as the hidden but suffixed with an underscore)
        var $hidden = $("#" + this.id.substr(0, this.id.length - 1));
        $hidden.val($(this).prop("checked") ? "Y" : "N");
    });
    if (isSafariDevice()) setSafariKeyboardPositionFixEvents();
    setupSelectLists();

    $.fn.dynDateTime = function () { }; //referred to in HtmlControls class, used with older versions of jQuery. Included here to allow for backwards compatibility.
});

function btnOver(btn, newColor) {
    if (newColor && newColor.length > 0) {
        var cap = document.getElementById(btn.id + '_caption');
        if (cap)
            cap.style.color = newColor;
    }
    btn.src = eval('img_' + btn.id + '_hover.src');
}

function btnOut(btn, newColor) {
    if (newColor && newColor.length > 0) {
        var cap = document.getElementById(btn.id + '_caption');
        if (cap)
            cap.style.color = newColor;
    }
    btn.src = eval('img_' + btn.id + '.src');
}

function btnDown(btn) {
    btn.src = eval('img_' + btn.id + '_click.src');
}

function btnUp(btn) {
    btn.src = eval('img_' + btn.id + '.src');
}

function pep_submitButtonSetEnabled(v) {
    var id = this.id;
    var cap = document.getElementById(id + '_caption');
    if (cap)
        cap.disabled = (v == false);
    this.disabled = (v == false);
    this.src = v ? eval('img_' + id + '.src') : eval('img_' + id + '_disabled.src');
}

function clearValidationSummary() {
    $("[data-valmsg-summary=true]")
        .addClass("validation-summary-valid")
        .removeClass("validation-summary-errors")
        .find("ul").empty();
    clearCaptionErrors();
}

function clearCaptionErrors() {
    $("label.capError").removeClass("capError");
}

function addCaptionErrors() {
    clearCaptionErrors();
    $(".input-validation-error").not(".disableErrorHighlight").each(function (index, element) {
        $("label[for='" + element.name + "']").addClass("capError");
        $("label[for='" + $(element).attr("data-forcontrol") + "']").addClass("capError");
    });
}

function addGroupHighlights(optionalElemToRestrictHighlightsTo) {
    var elemToSearch = $(document.documentElement);
    if (typeof (optionalElemToRestrictHighlightsTo) != 'undefined') {
        elemToSearch = optionalElemToRestrictHighlightsTo;
    }
    //if a contl within a highlightable area gains focus, highlight it and unhighlight any other highlighted areas. If it loses focus, unhighlight it.
    elemToSearch.find('.inputRowGroup').each(function () {
        var $inputRowGroup = $(this);
        $inputRowGroup.find('input[type=text], input[type=checkbox], input[type=password], input[type=radio], input[type=number], input[type=tel], input[type=email], .newListSelected, select').on('focus', function () {
            $('.inputRowGroup').removeClass('inputRowGroup-focus');
            $inputRowGroup.addClass('inputRowGroup-focus');
        })
        .on('blur', function () {
            $inputRowGroup.removeClass('inputRowGroup-focus');
        });
    });

    //if an area is clicked, highlight it and unhighlight any other highlighted areas.
    elemToSearch.find('.inputRowGroup').on('click', function () {
        $('.inputRowGroup').removeClass('inputRowGroup-focus');
        $(this).addClass('inputRowGroup-focus');
    });
}

function setupValidationOnPopupOpen($popup) {
    EnablePopupValidation($popup);
    ClearValidation($popup);
    $("#PageContainer [data-valmsg-summary=true]").attr("data-valmsg-summary", false);
    $popup.find("[data-valmsg-summary=false]").attr("data-valmsg-summary", true);
    saveOriginalValues($popup);
}

function setupValidationOnPopupClose($popup) {
    $("#PageContainer [data-valmsg-summary=false]").attr("data-valmsg-summary", true);
    $popup.find("[data-valmsg-summary=true]").attr("data-valmsg-summary", false);
    EnableParentValidation($popup);
}

function ClearValidation($popup) {
    clearValidationSummary();
    $popup.find('.validation-summary-errors').hide();
}

function EnablePopupValidation($popup) {
    pep.validation.validator.settings.ignore = ".ignore";
    $('input,select,textarea').addClass('ignore');
    $popup.find('input,select,textarea').removeClass('ignore');
}

function EnableParentValidation($popup) {
    $('input,select,textarea').removeClass('ignore');
    $popup.find('input,select,textarea').addClass('ignore');
}

function rebindUnobtrusiveValidation() {
    var $form = $("#incidents").closest("form");
    $form.removeData('validator');
    $form.removeData('unobtrusiveValidation');
    $.validator.unobtrusive.parse($form);
    pep.validation.validator = $form.data("validator");

    // When we reparsed the form, unobtrusive adds another submit handler to the end of the event queue. We need to move this back into it's 
    // original position in the queue (2nd, after our validation group submit handler) so that it fires before the submit handler we intentionally
    // wired to execute afterwards (3rd position) on _PurchaseLayout
    var submitEvents = $._data($form[0], "events").submit; // $form.data("events").submit;
    submitEvents[1] = submitEvents[submitEvents.length - 1];
    submitEvents.splice(submitEvents.length - 1, 1);
}

function saveOriginalValues($popup) {
    $popup.find("input,select,textarea").each(function (index, value) {
        $(value).data("originalValue", $(value).val());
    });
}

function restoreOriginalValues($popup) {
    $popup.find("input,select,textarea").each(function (index, value) {
        $(value).val($(value).data("originalValue"));
    });
}

function endsWith(str, suffix) {
    return str.indexOf(suffix, str.length - suffix.length) !== -1;
}

//In safari on mobile devices, the keyboard or select lists break fixed positioning, essentially pushing up the footer from the bottom. 
//Their implementation actually changes the position style to fixed and does not fix it, this repairs it.
function setSafariKeyboardPositionFixEvents() {
//    $bottomBars = $('.bottomBar');
//    var $controls = $('input, select');
//    $controls.on('focus', function () {
//        $bottomBars.css({ position: 'absolute' })
//        //$(window).scrollTop(0)
//    });
//    $controls.on('blur', function () {
//        $bottomBars.css({ position: 'fixed' })
//    });
}

function isValidZipFormat(zip, stateCd) {
    var regEx;
    var statePattern = '|' + stateCd + '|';
    var postCode = zip.substring(0, 3);

    if (stateLst.indexOf(statePattern) != -1 || mexicoLst.indexOf(statePattern) != -1) {
        var stateMatch = getPostalStateCd(postCode);
        if (stateMatch.indexOf(stateCd) == -1)
            return false;

        regEx = usZipRegEx;
    }
    else if (canadaLst.indexOf(statePattern) != -1)
        regEx = canadaZipRegEx;
    else
        return true;

    return regEx.test(zip);
}

function getPostalStateCd(postCode) {
    var stateCd = '';
    switch (postCode) {
        case '969': stateCd = 'TT'; break;
        case '008': stateCd = 'VI'; break;
        case '063': stateCd = 'CT,NY'; break;
        case '834': stateCd = 'ID,WY'; break;
        case '150': case '151': case '152': case '153': case '154': case '155': case '156': case '157': case '158': case '159': case '160': case '161': case '162': case '163': case '164': case '165': case '166': case '167': case '168': case '169': case '170': case '171': case '172': case '173': case '174': case '175': case '176': case '177': case '178': case '179': case '180': case '181': case '182': case '183': case '184': case '185': case '186': case '187': case '188': case '189': case '190': case '191': case '192': case '193': case '194': case '195': case '196': stateCd = 'PA'; break;
        case '530': case '531': case '532': case '534': case '535': case '537': case '538': case '539': case '540': case '541': case '542': case '543': case '544': case '545': case '546': case '547': case '548': case '549': stateCd = 'WI'; break;
        case '600': case '601': case '602': case '603': case '604': case '605': case '606': case '607': case '608': case '609': case '610': case '611': case '612': case '613': case '614': case '615': case '616': case '617': case '618': case '619': case '620': case '622': case '623': case '624': case '625': case '626': case '627': case '628': case '629': stateCd = 'IL'; break;
        case '030': case '031': case '032': case '033': case '034': case '035': case '036': case '037': case '038': stateCd = 'NH'; break;
        case '206': case '207': case '208': case '209': case '210': case '211': case '212': case '214': case '215': case '216': case '217': case '218': case '219': stateCd = 'MD'; break;
        case '480': case '481': case '482': case '483': case '484': case '485': case '486': case '487': case '488': case '489': case '490': case '491': case '492': case '493': case '494': case '495': case '496': case '497': case '498': case '499': stateCd = 'MI'; break;
        case '733': case '750': case '751': case '752': case '753': case '754': case '755': case '756': case '757': case '758': case '759': case '760': case '761': case '762': case '763': case '764': case '765': case '766': case '767': case '768': case '769': case '770': case '772': case '773': case '774': case '775': case '776': case '777': case '778': case '779': case '780': case '781': case '782': case '783': case '784': case '785': case '786': case '787': case '788': case '789': case '790': case '791': case '792': case '793': case '794': case '795': case '796': case '797': case '798': case '799': case '885': stateCd = 'TX'; break;
        case '660': case '661': case '662': case '664': case '665': case '666': case '667': case '668': case '669': case '670': case '671': case '672': case '673': case '674': case '675': case '676': case '677': case '678': case '679': stateCd = 'KS'; break;
        case '197': case '198': case '199': stateCd = 'DE'; break;
        case '460': case '461': case '462': case '463': case '464': case '465': case '466': case '467': case '468': case '469': case '470': case '471': case '472': case '473': case '474': case '475': case '476': case '477': case '478': case '479': stateCd = 'IN'; break;
        case '200': case '202': case '203': case '204': case '205': case '569': stateCd = 'DC'; break;
        case '800': case '801': case '802': case '803': case '804': case '805': case '806': case '807': case '808': case '809': case '810': case '811': case '812': case '813': case '814': case '815': case '816': stateCd = 'CO'; break;
        case '201': case '220': case '221': case '222': case '223': case '224': case '225': case '226': case '227': case '228': case '229': case '230': case '231': case '232': case '233': case '234': case '235': case '236': case '237': case '238': case '239': case '240': case '241': case '242': case '243': case '244': case '245': case '246': stateCd = 'VA'; break;
        case '039': case '040': case '041': case '042': case '043': case '044': case '045': case '046': case '047': case '048': case '049': stateCd = 'ME'; break;
        case '995': case '996': case '997': case '998': case '999': stateCd = 'AK'; break;
        case '028': case '029': stateCd = 'RI'; break;
        case '889': case '890': case '891': case '893': case '894': case '895': case '897': case '898': stateCd = 'NV'; break;
        case '430': case '431': case '432': case '433': case '434': case '435': case '436': case '437': case '438': case '439': case '440': case '441': case '442': case '443': case '444': case '445': case '446': case '447': case '448': case '449': case '450': case '451': case '452': case '453': case '454': case '455': case '456': case '457': case '458': case '459': stateCd = 'OH'; break;
        case '060': case '061': case '062': case '064': case '065': case '066': case '067': case '068': case '069': stateCd = 'CT'; break;
        case '700': case '701': case '703': case '704': case '705': case '706': case '707': case '708': case '710': case '711': case '712': case '713': case '714': stateCd = 'LA'; break;
        case '630': case '631': case '633': case '634': case '635': case '636': case '637': case '638': case '639': case '640': case '641': case '644': case '645': case '646': case '647': case '648': case '649': case '650': case '651': case '652': case '653': case '654': case '655': case '656': case '657': case '658': stateCd = 'MO'; break;
        case '290': case '291': case '292': case '293': case '294': case '295': case '296': case '297': case '298': case '299': stateCd = 'SC'; break;
        case '980': case '981': case '982': case '983': case '984': case '985': case '986': case '988': case '989': case '990': case '991': case '992': case '993': case '994': stateCd = 'WA'; break;
        case '010': case '011': case '012': case '013': case '014': case '015': case '016': case '017': case '018': case '019': case '020': case '021': case '022': case '023': case '024': case '025': case '026': case '027': case '055': stateCd = 'MA'; break;
        case '005': case '100': case '101': case '102': case '103': case '104': case '105': case '106': case '107': case '108': case '109': case '110': case '111': case '112': case '113': case '114': case '115': case '116': case '117': case '118': case '119': case '120': case '121': case '122': case '123': case '124': case '125': case '126': case '127': case '128': case '129': case '130': case '131': case '132': case '133': case '134': case '135': case '136': case '137': case '138': case '139': case '140': case '141': case '142': case '143': case '144': case '145': case '146': case '147': case '148': case '149': stateCd = 'NY'; break;
        case '570': case '571': case '572': case '573': case '574': case '575': case '576': case '577': stateCd = 'SD'; break;
        case '070': case '071': case '072': case '073': case '074': case '075': case '076': case '077': case '078': case '079': case '080': case '081': case '082': case '083': case '084': case '085': case '086': case '087': case '088': case '089': stateCd = 'NJ'; break;
        case '900': case '901': case '902': case '903': case '904': case '905': case '906': case '907': case '908': case '910': case '911': case '912': case '913': case '914': case '915': case '916': case '917': case '918': case '919': case '920': case '921': case '922': case '923': case '924': case '925': case '926': case '927': case '928': case '930': case '931': case '932': case '933': case '934': case '935': case '936': case '937': case '938': case '939': case '940': case '941': case '942': case '943': case '944': case '945': case '946': case '947': case '948': case '949': case '950': case '951': case '952': case '953': case '954': case '955': case '956': case '957': case '958': case '959': case '960': case '961': stateCd = 'CA'; break;
        case '970': case '971': case '972': case '973': case '974': case '975': case '976': case '977': case '978': case '979': stateCd = 'OR'; break;
        case '590': case '591': case '592': case '593': case '594': case '595': case '596': case '597': case '598': case '599': stateCd = 'MT'; break;
        case '730': case '731': case '734': case '735': case '736': case '737': case '738': case '739': case '740': case '741': case '743': case '744': case '745': case '746': case '747': case '748': case '749': stateCd = 'OK'; break;
        case '320': case '321': case '322': case '323': case '324': case '325': case '326': case '327': case '328': case '329': case '330': case '331': case '332': case '333': case '334': case '335': case '336': case '337': case '338': case '339': case '341': case '342': case '344': case '346': case '347': case '349': stateCd = 'FL'; break;
        case '716': case '717': case '718': case '719': case '720': case '721': case '722': case '723': case '724': case '725': case '726': case '727': case '728': case '729': stateCd = 'AR'; break;
        case '050': case '051': case '052': case '053': case '054': case '056': case '057': case '058': case '059': stateCd = 'VT'; break;
        case '350': case '351': case '352': case '354': case '355': case '356': case '357': case '358': case '359': case '360': case '361': case '362': case '363': case '364': case '365': case '366': case '367': case '368': case '369': stateCd = 'AL'; break;
        case '580': case '581': case '582': case '583': case '584': case '585': case '586': case '587': case '588': stateCd = 'ND'; break;
        case '832': case '833': case '835': case '836': case '837': case '838': stateCd = 'ID'; break;
        case '550': case '551': case '553': case '554': case '555': case '556': case '557': case '558': case '559': case '560': case '561': case '562': case '563': case '564': case '565': case '566': case '567': stateCd = 'MN'; break;
        case '006': case '007': case '009': stateCd = 'PR'; break;
        case '500': case '501': case '502': case '503': case '504': case '505': case '506': case '507': case '508': case '509': case '510': case '511': case '512': case '513': case '514': case '515': case '516': case '520': case '521': case '522': case '523': case '524': case '525': case '526': case '527': case '528': stateCd = 'IA'; break;
        case '300': case '301': case '302': case '303': case '304': case '305': case '306': case '307': case '308': case '309': case '310': case '311': case '312': case '313': case '314': case '315': case '316': case '317': case '318': case '319': case '398': case '399': stateCd = 'GA'; break;
        case '270': case '271': case '272': case '273': case '274': case '275': case '276': case '277': case '278': case '279': case '280': case '281': case '282': case '283': case '284': case '285': case '286': case '287': case '288': case '289': stateCd = 'NC'; break;
        case '680': case '681': case '683': case '684': case '685': case '686': case '687': case '688': case '689': case '690': case '691': case '692': case '693': stateCd = 'NE'; break;
        case '820': case '821': case '822': case '823': case '824': case '825': case '826': case '827': case '828': case '829': case '830': case '831': stateCd = 'WY'; break;
        case '967': case '968': stateCd = 'HI,AS'; break;
        case '400': case '401': case '402': case '403': case '404': case '405': case '406': case '407': case '408': case '409': case '410': case '411': case '412': case '413': case '414': case '415': case '416': case '417': case '418': case '420': case '421': case '422': case '423': case '424': case '425': case '426': case '427': stateCd = 'KY'; break;
        case '840': case '841': case '842': case '843': case '844': case '845': case '846': case '847': stateCd = 'UT'; break;
        case '850': case '852': case '853': case '855': case '856': case '857': case '859': case '860': case '863': case '864': case '865': stateCd = 'AZ'; break;
        case '386': case '387': case '388': case '389': case '390': case '391': case '392': case '393': case '394': case '395': case '396': case '397': stateCd = 'MS'; break;
        case '370': case '371': case '372': case '373': case '374': case '375': case '376': case '377': case '378': case '379': case '380': case '381': case '382': case '383': case '384': case '385': stateCd = 'TN'; break;
        case '247': case '248': case '249': case '250': case '251': case '252': case '253': case '254': case '255': case '256': case '257': case '258': case '259': case '260': case '261': case '262': case '263': case '264': case '265': case '266': case '267': case '268': stateCd = 'WV'; break;
        case '870': case '871': case '873': case '874': case '875': case '877': case '878': case '879': case '880': case '881': case '882': case '883': case '884': stateCd = 'NM'; break;
    }
    return stateCd;
}

var isMobile = {
    Android: function () {
        return navigator.userAgent.match(/Android/i);
    },
    BlackBerry: function () {
        return navigator.userAgent.match(/BlackBerry/i);
    },
    iOS: function () {
        return navigator.userAgent.match(/iPhone|iPad|iPod/i);
    },
    Opera: function () {
        return navigator.userAgent.match(/Opera Mini/i);
    },
    Windows: function () {
        return navigator.userAgent.match(/IEMobile/i);
    },
    any: function () {
        return (isMobile.Android() || isMobile.BlackBerry() || isMobile.iOS() || isMobile.Opera() || isMobile.Windows());
    }
};

function isSafariDevice() {
    return !!navigator.userAgent.match(/iPhone|iPad|iPod/i);
}

function isSafari() {
    return (navigator.userAgent.search("Safari") >= 0 && navigator.userAgent.search("Chrome") < 0);
}

function setupSelectLists() {
    $('select').not(".suppressNotPicked").each(function () {
        var $sel = $(this);

        var setSelectWatermarkStyle = function () {
            var $this = $(this);
            if ($this.val() == "") {
                $this.addClass('notPicked');
            } else $this.removeClass('notPicked');
        };

        $sel.on('change', setSelectWatermarkStyle);

        var prettyName = $sel.attr("data-default-text") || "Select one...";


        var $opt = $sel.find("option:first");
        if ($opt.val() == "" && (!isMobile.any() && !isSafari())) {
            $opt
                .attr("disabled", "disabled")
                .text(prettyName);
        }
        else if ($opt.val() == "") {
            $opt
                .text(prettyName);
        }

        setSelectWatermarkStyle.call($sel);
    });
}

function boostrapSize() {
    if (window.matchMedia("(max-width: 479px)").matches) return "xs";
    if (window.matchMedia("(min-width: 480px) and (max-width:767px)").matches) return "sm";
    if (window.matchMedia("(min-width: 768px) and (max-width:991px)").matches) return "md";
    if (window.matchMedia("(min-width: 992px)").matches) return "lg";
    return "";
}
